import * as React from "react";
import * as ReactDOM from "react-dom";
import { ButtonType, ButtonSize } from "./";

interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Wenn angegeben, wird hiermit das zugrunde liegende DOM-Element ermittelt..
     */
    buttonRef?: React.Ref<HTMLButtonElement>,

    /**
     * Titel Text.
     */
    title?: string,

    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Name des Icons welches angezeigt werden soll.
     */
    icon?: string,

    /**
     * Der Typ des Buttons.
     */
    type: ButtonType,

    /**
     * Gibt an ob der Button klein ist.
     */
    size?: ButtonSize,

    /**
     * Gibt an ob der Button abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e?: MouseEvent) => void
}

export class Button extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        type: ButtonType.default,
        size: ButtonSize.normal,
        isDisabled: false
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { style, buttonRef, title, text, icon, type, size, isDisabled } = this.props;
        var classNames: string[] = ["btn"];
        var iconContent: JSX.Element;
        var textContent: JSX.Element;

        if (size === ButtonSize.small)
            classNames.push("btn--small");
        else if (size === ButtonSize.big)
            classNames.push("btn--big");

        classNames.push(type);

        if (icon != null && text == null)
            classNames.push("btn--icon");

        if (icon != null)
        {
            iconContent = <i className={`mdi mdi-${icon}`}></i>;
        }

        if (text != null)
        {
            textContent = <span>{text}</span>;
        }

        return (
            <button
                style={style}
                ref={buttonRef}
                className={classNames.join(" ")}
                title={title}
                disabled={isDisabled}
                onClick={this.onClick}>
                {iconContent}
                {textContent}
            </button>
        );
    }
}